import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Mail, Lock, LogIn } from 'lucide-react';
import { toast } from 'react-toastify';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Hoş geldiniz, ${user.fullName}!`);
      navigate(user.role === 'customer' ? '/dashboard' : '/staff/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Giriş hatası');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900 flex">
      {/* Left Side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 items-center justify-center p-12">
        <div className="max-w-lg">
          <img src="/logo.png" alt="DSY" className="h-24 mb-8 drop-shadow-2xl" />
          <h1 className="text-5xl font-bold text-white mb-6 leading-tight">Destek Talep<br />Yönetim Sistemi</h1>
          <p className="text-xl text-blue-200 leading-relaxed">
            Müşterilerinizin destek taleplerini kolayca yönetin. Hızlı, güvenilir ve profesyonel destek deneyimi.
          </p>
          <div className="mt-12 grid grid-cols-2 gap-6">
            {[
              { num: '7/24', desc: 'Destek Erişimi' },
              { num: 'Anlık', desc: 'Bildirimler' },
              { num: 'Güvenli', desc: 'Dosya Paylaşımı' },
              { num: 'Kolay', desc: 'Talep Takibi' }
            ].map((item, i) => (
              <div key={i} className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/10">
                <p className="text-2xl font-bold text-white">{item.num}</p>
                <p className="text-blue-200 text-sm">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden text-center mb-8">
            <img src="/logo.png" alt="DSY" className="h-16 mx-auto mb-4 drop-shadow-xl" />
            <h1 className="text-2xl font-bold text-white">Destek Sistemi</h1>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <h2 className="text-2xl font-bold text-slate-800 mb-2">Giriş Yap</h2>
            <p className="text-slate-500 mb-8">Hesabınıza giriş yapın</p>

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">E-posta</label>
                <div className="relative">
                  <Mail size={18} className="absolute left-3 top-3 text-slate-400" />
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                    className="w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-800 placeholder-slate-400"
                    placeholder="ornek@email.com" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">Şifre</label>
                <div className="relative">
                  <Lock size={18} className="absolute left-3 top-3 text-slate-400" />
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                    className="w-full pl-10 pr-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-slate-800 placeholder-slate-400"
                    placeholder="••••••••" />
                </div>
              </div>

              <button type="submit" disabled={loading}
                className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-600/25 disabled:opacity-50 flex items-center justify-center gap-2">
                {loading ? <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" /> : <><LogIn size={20} /> Giriş Yap</>}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-slate-500 text-sm">
                Personel girişi için yetkilendirilmiş hesabınızla giriş yapın.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
